import React from 'react';
import { Button } from 'ui';
import { routes } from 'constants/config';
import Tooltip from 'components/shared/Tooltip';
import EditPermissionNeeded from 'components/shared/EditPermissionNeeded';

const ScenarioOverviewHeader = ({ scenario, userCanEditScenario }) => (
  <div className="ScenarioOverviewHeader">
    <div>
      <div className="d-f jc-sb ai-fs mb-16">
        <h1 className="ff-ss ws-pr mr-8">
          {scenario.title ||
            t('practice.on_demand_practice.overview.untitled_scenario')}
        </h1>
        <div className="f-sh-0">
          {userCanEditScenario && (
            <Tooltip
              text={
                scenario.archived &&
                t('practice.on_demand_practice.overview.archived_note')
              }
            >
              <Button
                primary
                disabled={scenario.archived}
                url={routes.ON_DEMAND_PRACTICE.CREATOR.EDIT(scenario.id)}
              >
                {t('practice.on_demand_practice.overview.edit_scenario')}
              </Button>
            </Tooltip>
          )}
          {!userCanEditScenario && <EditPermissionNeeded />}
        </div>
      </div>
    </div>
  </div>
);

export default ScenarioOverviewHeader;
